import React from 'react';
import BrandLogo from '../components/BrandLogo';
import AppVersion from '../components/AppVersion';
import LegalSectionCard from '../components/legal/LegalSectionCard';
import LegalSubsection from '../components/legal/LegalSubsection';
import SummaryCard from '../components/legal/SummaryCard';
import {
  EULA_SECTIONS,
  EULA_SUMMARY,
  PRIVACY_SECTIONS,
  PRIVACY_SUMMARY,
  TERMS_OF_SERVICE_SECTIONS,
  TERMS_OF_SERVICE_SUMMARY,
  FINAL_SUMMARY_SECTIONS,
} from '../content/termsContent';
import '../components/legal/legal.css';
import './TermsAndConditions.css';

const renderSections = (sections) =>
  sections.map((section, index) => (
    <LegalSubsection
      key={section.title}
      index={index + 1}
      title={section.title}
      paragraphs={section.paragraphs}
      bullets={section.bullets}
      subsections={section.subsections}
      contact={section.contact}
    />
  ));

const TermsAndConditions = () => (
  <div className="terms-page">
    <div className="terms-page__inner">
      <header className="terms-page__header">
        <BrandLogo variant="compact" plate className="terms-page__logo" />
        <h1 className="terms-page__title">Legal Information</h1>
        <p className="terms-page__subtitle">
          End User Licence Agreement, Privacy Policy, and Terms of Service for Alter Salon.
        </p>
      </header>

      <main className="terms-page__main">
        <LegalSectionCard id="eula" title="End User Licence Agreement (EULA)">
          {renderSections(EULA_SECTIONS)}
          <SummaryCard>{EULA_SUMMARY}</SummaryCard>
        </LegalSectionCard>

        <LegalSectionCard id="privacy-policy" title="Privacy Policy">
          {renderSections(PRIVACY_SECTIONS)}
          <SummaryCard>{PRIVACY_SUMMARY}</SummaryCard>
        </LegalSectionCard>

        <LegalSectionCard id="terms-of-service" title="Terms of Service">
          {renderSections(TERMS_OF_SERVICE_SECTIONS)}
          <SummaryCard>{TERMS_OF_SERVICE_SUMMARY}</SummaryCard>
        </LegalSectionCard>

        <section className="legal-final-card" aria-labelledby="legal-overview-title">
          <h2 id="legal-overview-title" className="legal-final-card__title">
            Legal Overview
          </h2>
          {renderSections(FINAL_SUMMARY_SECTIONS)}
        </section>
      </main>

      <footer className="terms-page__footer">
        <AppVersion className="terms-page__version" />
      </footer>
    </div>
  </div>
);

export default TermsAndConditions;
